export enum FORM_ERROR_MESSAGES {
  REQUIRED = "field is required",
  LONG = "is too long",
  SHORT = "is too short",
  PASSWORDS_MATCH = "Passwords do not match",
  NUMBER = "must be a number",
  EMAIL = "Please enter a valid email",
  PHONE_NUMBER = "Please enter a valid phone number",
  UPPERCASE = "At least 1 uppercase letter",
  LOWERCASE = "At least 1 lowercase letter",
  DIGIT = "At least 1 digit",
  ONLY_TEXT = "must be without numbers",
  BAD_LOGIN = "Entered credentials are invalid",
  TRIM = "Remove leading and trailing spaces",
}
